import _default from './Divider';
export { _default as default };